import { RuleResult } from '../../../../types/DeclarationP5'

interface Parameters {
  security: string
  additionalDeclarationType: string
}

const validatePlaceOfRequirement = ({
  security,
  additionalDeclarationType,
}: Parameters): RuleResult => {
  if (!['1', '3'].includes(security)) return 'NOT_ALLOWED'

  return additionalDeclarationType === 'D' ? 'OPTIONAL' : 'REQUIRED'
}

const C0932Validator = {
  validatePlaceOfAcceptanceRequirement: (params: Parameters): RuleResult => validatePlaceOfRequirement(params),
  validatePlaceOfDeliveryRequirement: (params: Parameters): RuleResult => validatePlaceOfRequirement(params),
}

export default C0932Validator
